import React, { useState, useEffect } from "react";
import { Form, Button, Modal, Row, Col, Spin } from "antd";
import { vsmNotify, vsmRTOPlaces } from "../../../../config/messages";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import InputComponent from "../../../../component/InputComponent";
import debounce from "lodash/debounce";

const AddComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		ManageRTOPlacesStore,
		ManageRTOPlacesStore: { AddData },
	} = useStore();
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);
	const [fetchZone, setFetchZone] = useState(true);

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		setSaving(true);
		AddData(data)
			.then((data) => {
				close();
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
			})
			.catch((e) => {
				if (e.errors) {
					form.setFields(e.errors);
				}
			})
			.finally(() => setSaving(false));
	};

	useEffect(() => {
		form.setFieldsValue({
			is_outer_rto: 0
			
		})
	},[form])

	// check for valid form values then accordingly make save button disable / enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setDisabled(true);
	};

	return (
		<Modal
			className="addModal"
			centered
			title="New RTO Place"
			width={534}
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					disabled={disabled}
					form="addRTOPlacesForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>,
			]}
		>
			<Form
				form={form}
				id="addRTOPlacesForm"
				onFinish={handleSubmit}
				labelCol={{ span: 24 }}
				onChange={handleChange}
			>
				<Row gutter={30}>
				<Col xs={{ span: 24 }}>
						<InputComponent
							type="text"
							required
							label="Name"
							placeholder="Name"
							name="name"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.name}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="text"
							required
							label="Code"
							placeholder="Code"
							name="code"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.code}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="select"
							allowClear
							required
							autoComplete="chrome-off"
							label="Zone"
							name="zone_id"
							placeholder="Select Zone"
							rules={vsmRTOPlaces.validation.zone_id}
							onChange={handleChange}
							onFocus={() =>
								fetchZone && ManageRTOPlacesStore.getZoneList().then(() => setFetchZone(false))
							}
							notFoundContent={
								fetchZone ? <Spin size="small" /> : "No Record Found."
							}
							options={{
								values: ManageRTOPlacesStore.dropdown_zone_list,
								value_key: "id",
								text_key: "name",
								rejected_keys:
									ManageRTOPlacesStore.dropdown_zone_list && !fetchZone &&
									ManageRTOPlacesStore.dropdown_zone_list
										.filter((item) => item.status === 0)
										.map((item) => item.id),
							}}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="text"
							required
							label=" CKD Hypo charge"
							placeholder="CKD Hypothecation charge"
							name="ckd_hypo_charges"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.ckd_hypo_charges}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="text"
							required
							label="CKD Other Charge"
							placeholder="CKD Other Charge"
							name="ckd_other_charges"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.ckd_other_charges}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="text"
							required
							label=" CBU Hypo charge"
							placeholder="CBU Hypothecation charge"
							name="cbu_hypo_charges"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.cbu_hypo_charges}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="text"
							required
							label="CBU Other Charge"
							placeholder="CBU Other Charge"
							name="cbu_other_charges"
							onChange={handleChange}
							rules={vsmRTOPlaces.validation.cbu_other_charges}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 12 }}>
						<InputComponent
							type="radio_button"
							label="Is Outer RTO ?"
							name="is_outer_rto"
							defaultValue={0}
							options={{
								values: [
									{ id: 0, name: "No" },
									{ id: 1, name: "Yes" },
								],
								value_key: "id",
								text_key: "name",
							}}
						/>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
});

export default AddComponent;
